import { render, staticRenderFns } from "./proof-view-lang.vue?vue&type=template&id=ce95e0e0&scoped=true&"
import script from "./proof-view-lang.vue?vue&type=script&lang=js&"
export * from "./proof-view-lang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce95e0e0",
  null
  
)

export default component.exports